export const THESES_FILTER = 'THESES_FILTER'
export const thesesFilter = filters => ({ type: THESES_FILTER, filters })

export const THESES_REQUEST = 'THESES_REQUEST'
export const thesesRequest = () => ({ type: THESES_REQUEST })

export const THESES_RECEIVE = 'THESES_RECEIVE'
export const thesesReceive = theses => ({ type: THESES_RECEIVE, theses })
